<lo-grandmaster #gm (finishedLoading)="addToGrandmaster($event, data)" *ngIf="data !== undefined" class="noPrint" id="grandmaster" />
